// import 文を使って sub.js ファイルを読み込む。
import { backfaceFixed } from "./lib/backfaceFixed";
import { ua } from "./lib/userAgent";
import { vpFixed } from "./lib/viewportFixUnder360";
import objectFitImages from "object-fit-images";
import { search } from "./lib/search";

//初期化
// vpFixed();
objectFitImages();